export default __webpack_public_path__ + "static/chainsColored-73f2785fd9fbc8dee5200d1a970d26a7.png";